import { useQuery } from '@tanstack/react-query';
import type { AppointmentType } from '@kontor/shared';
import { api } from '../../api';
import { useSession } from '../../session';

/** Die Terminarten des Mandanten, für Kalender und Termin-Formular. Wer Termine nicht lesen darf, bekommt keine Liste. */
export function useAppointmentTypes() {
  const { can, hasModule } = useSession();
  const enabled = hasModule('calendar') && can('calendar.read');
  const query = useQuery({
    queryKey: ['appointment-types'],
    queryFn: async () => (await api<{ data: AppointmentType[] }>('GET', '/appointment-types')).data,
    enabled,
    staleTime: 5 * 60_000,
  });
  const list = query.data ?? [];
  return {
    list,
    isLoading: query.isLoading,
    find: (id: string | null): AppointmentType | undefined => (id ? list.find((t) => t.id === id) : undefined),
  };
}

export { toneClass } from '../../components/color/ColorSwatches';
